<div class="popup-overlay" id="deletePopup">
  <div class="popup-dialog">
    <h3 class="popup-title">Leave Checkout?</h3>
    <p class="popup-message">Your payment validation will be lost and you'll need to re-enter your credit card information to complete your order.</p>
    <div class="popup-buttons">
      <button class="popup-btn popup-btn-cancel" (click)="closeConfirmationPopUp()">Stay</button>
      <button class="popup-btn popup-btn-delete" (click)="confirmToGoToCart()">Leave</button>
    </div>
  </div>
</div>